import { useContext } from "react"
import { AppContext } from "./context"

const UiButton1 = ({ text, submit, width, type = 1 }) => {

	const { dataFetchLoading } = useContext(AppContext)

	if (type == 1) {
		return (
			<div
				style={{ cursor: "pointer", width: width ? width : '100%' }}
				onClick={dataFetchLoading ? null : submit}
				className="button1 d-flex justify-content-center">

				<p className="fs-5 text-white mb-0 align-self-center">{text}</p>

			</div>
		)
	}
	if (type == 2) {
		return (
			<div
				style={{ cursor: "pointer", width: width ? width : '100%' }}
				onClick={dataFetchLoading ? null : submit}
				className="button3 d-flex justify-content-center">

				<p className="fs-5 mb-0 align-self-center ">{text}</p>

			</div>
		)
	}

}

export default UiButton1